function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import PropTypes from 'prop-types';
import withStyles from 'isomorphic-style-loader/withStyles';
import { injectIntl } from 'react-intl';
import Header from './Header';
import Table from './Table';
import styles from './PatientGestationalReport.pcss';
var _React_PureComponent;
class PatientGestationalReport extends (_React_PureComponent = React.PureComponent) {
    render() {
        return /*#__PURE__*/ _jsxs("div", {
            className: styles.patientsGestationalReport,
            id: "gestationalReportPrint",
            children: [
                /*#__PURE__*/ _jsx(Header, {
                    phiSet: this.props.phiSet,
                    accountPatientProfile: this.props.accountPatientProfile,
                    standards: this.props.standards,
                    conversion: this.props.conversion,
                    reportsDates: this.props.reportsDates
                }),
                /*#__PURE__*/ _jsx(Table, {
                    readings: this.props.readings,
                    reportsDates: this.props.reportsDates,
                    conversion: this.props.conversion
                })
            ]
        });
    }
}
_define_property(PatientGestationalReport, "propTypes", {
    // Explicit props
    conversion: PropTypes.object.isRequired,
    standards: PropTypes.shape({
        maxValue: PropTypes.number.isRequired,
        preMeal: PropTypes.shape({
            highThreshold: PropTypes.number.isRequired,
            lowThreshold: PropTypes.number.isRequired
        }),
        postMeal: PropTypes.shape({
            highThreshold: PropTypes.number.isRequired,
            lowThreshold: PropTypes.number.isRequired
        })
    }),
    readings: PropTypes.array,
    phiSet: PropTypes.object,
    accountPatientProfile: PropTypes.object,
    reportsDates: PropTypes.object
});
export default withStyles(styles)(injectIntl(PatientGestationalReport));
